<template>
  <div :class="d._class" :id="d._id">
    <div class="container">
      <h3>{{d._title}}</h3>
      <p class="paragraph" v-for="(x, i) of d.paragraphs" :key="i">{{x}}</p>

      <ul class="call">
        <li v-for="(x, i) of d.topics" :key="i">{{x}}</li>
      </ul>

      <p class="submission">
        Submission Page:
        <b>
          <a :href="d.submissionPageUrl" style="color:crimson">click here</a>
        </b>
      </p>
    </div>
  </div>
</template>

<script>
import { idify } from "@/assets/js/common";
export default {
  name: "CallForPaper",
  props: {
    datum: {
      type: Object,
      default: function() {
        return {
          paragraphs: [],
          topics: [],
          submissionPageUrl: ""
        };
      }
    }
  },
  data() {
    return {
      d: {
        _class: "team",
        _title: "Call For Paper",
        _id: "CallForPaper",

        ...this.datum
      }
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.paragraph {
  margin-top: 3em;
  font-size: 1.5em;
}

.call {
  //   margin-top: 3em;
  font-size: 1.3em;
}

.submission {
  margin-top: 0.5em;
  font-size: 1.5em;
  color: crimson;
  a {
    color: crimson;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CallForPaper.vue